"use client";
import { createThemeFactory } from '../shared/create-theme-factory';
import { createOptions as createBaseOptions } from "./base/create-options";
import { createOptions as createDarkOptions } from "./dark/create-options";
import { createOptions as createLightOptions } from "./light/create-options";
import { createTypography } from "./base/create-typography";

export const COMPONENTS = {
  DRAWER_WIDTH: 280,
};

export const createTheme = createThemeFactory({
  createBaseOptions,
  createDarkOptions,
  createLightOptions,
  createTypography,
});

export const theme = createTheme({});

